import type Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { isDev } from "@memorang/constants";
import type { TFunction } from "i18next";
import { LearningModes } from "../types";

const learningModeIcon: Record<string, keyof typeof Icon.glyphMap> = {
	flip: "cards-outline",
	quiz: "format-list-checks",
	match: "checkerboard",
	questionSet: "format-list-checks",
	simulations: "call-split",
	questions: "order-bool-descending",
	writing: "pencil-outline",
	listening: "ear-hearing",
	speaking: "microphone-outline",
	reading: "book-open-page-variant-outline",
};

type GetLearningModesArgs = {
	numQuestions?: number;
	numWriting?: number;
	numListening?: number;
	numSpeaking?: number;
	numReading?: number;
	t?: TFunction;
};

const getLearningModes = ({
	numQuestions = 0,
	numWriting = 0,
	numListening = 0,
	numSpeaking = 0,
	numReading = 0,
	t,
}: GetLearningModesArgs) => [
	...(numQuestions > 0
		? [
				{
					title: t ? t("learningModes.questions") : "Questions",
					icon: learningModeIcon.questions,
					value: LearningModes.questions,
					count: numQuestions,
					disabled: !numQuestions,
				},
			]
		: []),
	{
		title: t ? t("learningModes.reading") : "Reading",
		icon: learningModeIcon.reading,
		value: LearningModes.reading,
		count: numReading,
		disabled: !numReading,
	},
	{
		title: t ? t("learningModes.listening") : "Listening",
		icon: learningModeIcon.listening,
		value: LearningModes.listening,
		count: numListening,
		disabled: !numListening,
	},
	{
		title: t ? t("learningModes.writing") : "Writing",
		icon: learningModeIcon.writing,
		value: LearningModes.writing,
		count: numWriting,
		disabled: !numWriting,
	},
	{
		title: t ? t("learningModes.speaking") : "Speaking",
		icon: learningModeIcon.speaking,
		value: LearningModes.speaking,
		count: numSpeaking,
		disabled: !numSpeaking,
	},
];

const tagIds = {
	reading: isDev ? 6479 : 1146,
	writing: isDev ? 6480 : 1147,
	listening: isDev ? 6482 : 1149,
	speaking: isDev ? 6481 : 1148,
} as const;

export { getLearningModes, learningModeIcon, tagIds };
